import type { QueryClient } from '@tanstack/react-query';
import { tradesKeys } from '@/services/query-keys/trades-keys';
import { cashPoolKeys } from '@/services/query-keys/cash-pool-keys';

/**
 * LR-586: a trade write can move the cash pool ledger — booking posts
 * `price + margin`, an amend re-syncs it, cancel and partial return take it back
 * out — so the pool registry has to go stale together with the trade book.
 * LR-587 added the repo side: posting a margin call is a posting too
 * (`use-post-repo-margin-call`).
 *
 * Without this the Collateral Manager Balance column keeps its five-minute
 * cached figure and tells the operator a pool is empty while the deactivation
 * guard 400s with the balance the screen is not showing. One helper rather than
 * a line per hook, so a new posting site is one import, not a rediscovery.
 *
 * Not awaited, deliberately: `invalidateQueries` marks the trees stale and
 * TanStack refetches the loaded queries in the background. Awaiting a full-book
 * refetch here is what LR-546 removed — it kept the dialog in its "Creating…"
 * state until the whole position book reloaded, and operators re-submitted.
 */
export const invalidateTradeAndPoolCaches = (queryClient: QueryClient): void => {
  void queryClient.invalidateQueries({ queryKey: tradesKeys.all });
  void queryClient.invalidateQueries({ queryKey: cashPoolKeys.all });
};
